export default __webpack_public_path__ + "static/media/woman-head-icon-1.3ed6bfae.svg";